import * as React from 'react';
import {Category} from '@models/category';
import {Button, Divider, Modal, Table, Avatar} from 'antd';
import {FormattedMessage, injectIntl, intlShape} from 'react-intl';
import FormattedDateTime from "@components/custom/FormattedDateTime";
import Message from "@constants/message";
import {PaginationDefaultParams} from "@components/custom/Paginator";
import {CategoryTypeOptions} from "@models/category";
import TextWithTooltip from "../custom/TextWithTooltip";
import {NavLink} from "react-router-dom";


type Props = {
  data: Category[],
  loading: boolean,
  deleteFn: (item: Category) => void;
  intl: intlShape.isRequired
  currentPage: number
};


const CategoriesTable: React.FC<Props> = props => {
  const {data, loading, currentPage, deleteFn, intl} = props;
  const {formatMessage} = intl;
  const pageOffset = (currentPage - 1) * PaginationDefaultParams.count;
  
  const deleteCategory = (item: Category): void => {
    Modal.confirm({
      content: formatMessage({
        id: "app.general_delete_warning",
        defaultMessage: Message.Warning.Delete,
      }),
      okText: formatMessage({
        id: "app.delete",
        defaultMessage: "Delete",
      }),
      cancelText: formatMessage({
        id: "app.cancel",
        defaultMessage: "Cancel",
      }),
      className: "delete-confirm-dialog",
      onOk: () => deleteFn(item),
    });
  };
  
  const columns = [
    {
      title: <FormattedMessage id="app.index" defaultMessage={`Index`}/>,
      width: 30,
      dataIndex: 'index',
      key: 'id',
      render: (a, b, i) => <span>{i + 1 + pageOffset}</span>
    },
    {
      title: "",
      width: 30,
      dataIndex: 'thumbnail_image_file',
      key: 'thumbnail_image_file',
      render: (a, record) => <Avatar shape="circle"
                                     size="small"
                                     src={record.thumbnail_image_file ? record.thumbnail_image_file.path : null}
      />
    },
    {
      title: <FormattedMessage id="app.title" defaultMessage={`Title`}/>,
      width: 150,
      dataIndex: 'title',
      key: 'title'
    },
    {
      title: <FormattedMessage id="app.type" defaultMessage={`Type`}/>,
      width: 100,
      dataIndex: 'type',
      key: 'type',
      render: (type) => {
        return CategoryTypeOptions.find(opt => opt.value == type).label
      }
    },
    {
      title: <FormattedMessage id="app.slug" defaultMessage={`Slug`}/>,
      width: 100,
      dataIndex: 'slug',
      key: 'slug',
    },
    {
      title: <FormattedMessage id="app.body" defaultMessage={`Description`}/>,
      width: 200,
      dataIndex: 'body',
      key: 'body',
      render: (text) => <TextWithTooltip text={text || ""}/>
    },
    {
      title: <FormattedMessage id="app.creation_date" defaultMessage={`Creation Date`}/>,
      width: 120,
      dataIndex: 'created_at',
      key: 'created_at',
      render: (text, record) => <FormattedDateTime date={text}/>
    },
    {
      title: '',
      key: 'actions',
      width: 90,
      dataIndex: 'actions',
      render: (text, record) => (
        <span>
          <NavLink to={`/categories/${record.id}/edit`}>
            <Button type="link" size={`small`}>
             <FormattedMessage id="app.edit" defaultMessage={`Edit`}/>
           </Button>
          </NavLink>

          <Divider type="vertical" size={`small`}/>

          <Button type="link" className={`danger`} onClick={() => deleteCategory(record)}>
            <FormattedMessage id="app.delete" defaultMessage={`Delete`}/>
          </Button>
        </span>
      ),
    },
  ];
  
  
  return (
    <Table columns={columns}
           loading={loading}
           pagination={false}
           dataSource={data}
           rowKey='id'/>
  )
  
};

export default injectIntl(CategoriesTable)